<template>
  <div class="pull-auto top-menu">
    <!--<el-menu :default-active="activeIndex"-->
             <!--mode="horizontal"-->
             <!--text-color="#606266">-->
      <!--<template v-for="(item,index) in items">-->
        <!--<el-menu-item :index="item.id+''"-->
                      <!--@click.native="openMenu(item)"-->
                      <!--:key="index">-->
          <!--<template slot="title">-->
            <!--<i :class="item.icon"></i>-->
            <!--<span slot="title">{{item.label}}</span>-->
          <!--</template>-->
        <!--</el-menu-item>-->
      <!--</template>-->
    <!--</el-menu>-->
  </div>
</template>

<script>
import { resolveUrlPath } from "@/util/util";
import { mapGetters } from "vuex";
export default {
  name: "top-menu",
  data () {
    return {
      activeIndex: '1',
      items: [
        // {
        //   label: "首页",
        //   href: "/wel/index",
        //   icon: 'el-icon-menu',
        //   parentId: 0
        // },
        // {
        //   label: "设置",
        //   icon: 'el-icon-setting',
        //   href: '/dev/index',
        //   parentId: 1
        // },
        // {
        //   label: "文档",
        //   icon: 'el-icon-document',
        //   href: "https://www.kancloud.cn/smallwei/avue/",
        //   parentId: 3
        // }
      ]
    };
  },
  created () {
      // this.$store.dispatch("GetSystems").then((systems) => {
      //     this.items = systems;
      // })


      // console.log(this.items)
  },
  computed: {
    ...mapGetters(["tagCurrent", "menu"])
  },
  methods: {
    openMenu () {
      // this.$store.dispatch("GetMenu").then(() => {
      //   let itemActive;
      //   //   childItemActive = 0;
      //   // if (item.href) {
      //   //   itemActive = item;
      //   // } else {
      //   //   if (this.menu[childItemActive].length == 0) {
      //   //     itemActive = this.menu[childItemActive];
      //   //   } else {
      //       itemActive = this.menu;
      //   //   }
      //   // }
      //
      //   this.$router.push({
      //     path: resolveUrlPath(itemActive.href, itemActive.label)
      //   });
      // });
    }
  }
};
</script>

<style scoped="scoped" lang="scss">
.top-menu {
  margin-top: -4px;
  box-sizing: border-box;
}
</style>